import React from 'react';
import SectionCard from 'components/organisms/section_card';

const SituacaoSection = ({ data }: any) => {
  if (!data) return null;

  return (
    <SectionCard title="Situação atual" icon="description">
      <p className="mb-0">{data}</p>
    </SectionCard>
  );
};

export default SituacaoSection;
